"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIButton = _interopRequireDefault(require("../../button/UIButton"));

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _SimpleDateTypes = require("../../types/SimpleDateTypes");

var _SimpleDate = require("../../core/SimpleDate");

var _createLazyPropType = _interopRequireDefault(require("../../utils/propTypes/createLazyPropType"));

var _lazyEval = _interopRequireDefault(require("../../utils/lazyEval"));

var _UITooltip = _interopRequireDefault(require("../../tooltip/UITooltip"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-basis: 50%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  justify-content: space-between;\n  margin: 16px 0 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Outer = _styledComponents.default.div.withConfig({
  displayName: "CalendarFooterButtons__Outer",
  componentId: "sc-1y52nyw-0"
})(_templateObject());

var Button = (0, _styledComponents.default)(_UIButton.default).withConfig({
  displayName: "CalendarFooterButtons__Button",
  componentId: "sc-1y52nyw-1"
})(_templateObject2());

var CalendarFooterButtons =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(CalendarFooterButtons, _PureComponent);

  function CalendarFooterButtons() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CalendarFooterButtons);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CalendarFooterButtons)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleTodayClick = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          today = _this$props.today;
      onChange((0, _SyntheticEvent.default)(today));
    };

    _this.handleClearClick = function () {
      var onChange = _this.props.onChange;
      onChange((0, _SyntheticEvent.default)(null));
    };

    return _this;
  }

  (0, _createClass2.default)(CalendarFooterButtons, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          clearLabel = _this$props2.clearLabel,
          max = _this$props2.max,
          maxValidationMessage = _this$props2.maxValidationMessage,
          min = _this$props2.min,
          minValidationMessage = _this$props2.minValidationMessage,
          __onChange = _this$props2.onChange,
          today = _this$props2.today,
          todayLabel = _this$props2.todayLabel,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["clearLabel", "max", "maxValidationMessage", "min", "minValidationMessage", "onChange", "today", "todayLabel"]);
      var todayButtonDisabled = !(0, _SimpleDate.isDateInRange)(today, min, max);
      return _react.default.createElement(Outer, rest, _react.default.createElement(_UITooltip.default, {
        title: todayButtonDisabled && (0, _lazyEval.default)(min && (0, _SimpleDate.compare)(today, min) === -1 ? minValidationMessage : maxValidationMessage)
      }, _react.default.createElement(Button, {
        "data-action": "today",
        disabled: todayButtonDisabled,
        use: "tertiary-light",
        size: "xs",
        onClick: this.handleTodayClick,
        responsive: false
      }, (0, _lazyEval.default)(todayLabel))), _react.default.createElement(Button, {
        "data-action": "clear",
        use: "tertiary-light",
        size: "xs",
        onClick: this.handleClearClick,
        responsive: false
      }, (0, _lazyEval.default)(clearLabel)));
    }
  }]);
  return CalendarFooterButtons;
}(_react.PureComponent);

if (process.env.NODE_ENV !== 'production') {
  CalendarFooterButtons.propTypes = {
    clearable: _propTypes.default.bool,
    clearLabel: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
    max: _SimpleDateTypes.SimpleDateType,
    maxValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
    min: _SimpleDateTypes.SimpleDateType,
    minValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
    onChange: _propTypes.default.func.isRequired,
    today: _SimpleDateTypes.SimpleDateType.isRequired,
    todayLabel: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired
  };
}

CalendarFooterButtons.defaultProps = {
  clearable: true,
  clearLabel: function clearLabel() {
    return _I18n.default.text('ui.datePicker.clear');
  },
  todayLabel: function todayLabel() {
    return _I18n.default.text('ui.datePicker.today');
  }
};
CalendarFooterButtons.displayName = 'CalendarFooterButtons';
var _default = CalendarFooterButtons;
exports.default = _default;
module.exports = exports.default;